import { handleResponse } from '@oneToOne/shared/services/rest/apiService'

import { defaultApiHost } from '@src/helpers'

/**
 * Checks if all agents in the chat channel are in a video call
 */
export async function getAllAgentsInVideoCall(
  chatChannelId: string,
  apiHost = defaultApiHost,
): Promise<{ all_agents_in_video_call: boolean }> {
  const response = await fetch(
    `${apiHost}/api/chat_channels/${chatChannelId}/all_agents_in_video_call`,
  )
  return handleResponse(response)
}
